import { TableColumn } from '../../../components/forms/form-entries/form-entry-list/entry-list/dynamic-table/dynamic-table.component';
import { getFormTitle } from '../../../utils/form-model-map';

export class AllFormsBySubmitterListItem {


    /** The person who submitted the form ("User" column) */
    submittedByName: string | null = null;

    
  /** When the form was submitted ("Entry Date" column) */
  submissionDate: Date | null = null;



  /** Job Name */
  jobName: string | null = null;

  /** Form Type */
  formType: string | null = null;



  id: string = '';

  constructor(data?: Partial<AllFormsBySubmitterListItem>) {
    if (data) {
      Object.assign(this, data);
      // Compute form title from form type
      if (this.formType) {
        this.formType = getFormTitle(this.formType);
      }
    }
  }
  static getFieldMappings(): Record<string, string> {
    return {
        submittedByName: "Submitter Name",
        submissionDate: "Submission Date",
        jobName: "Job Name",
        formType: "Form Type",
    };
  }

  static getTableColumns(): TableColumn[] {
    const columns: TableColumn[] = [];
    const instance = new AllFormsBySubmitterListItem();
    const fieldMappings = this.getFieldMappings();
    
    // Get all properties of the class
    Object.keys(instance).forEach(key => {
      // Skip the id property as it's handled separately
      if (key === 'id') return;

      // Determine the type based on the property value
      let type: 'text' | 'date' | 'action' | 'status' = 'text';
      const value = instance[key as keyof AllFormsBySubmitterListItem];
      
      if (value instanceof Date || (value === null && key.toLowerCase().includes('date'))) {
        type = 'date';
      }
      // All other values default to 'text' type

      // Add the column if it has a mapping
      if (fieldMappings[key]) {
        columns.push({
          key,
          label: fieldMappings[key],
          type,
          sortable: true
        });
      }
    });

    return columns;
  }

  static fromApiResponse(data: any): AllFormsBySubmitterListItem {
    return new AllFormsBySubmitterListItem({
      id: data.id,
      submissionDate: data.formEntryData?.submissionDate ? new Date(data.formEntryData.submissionDate) : null,
      submittedByName: data.formEntryData?.submittedByName || null,
      jobName: data.formEntryData?.jobName || null,
      formType: data.formType || null,
    });
  }
} 